import React, { useState, useEffect } from "react";
import "./Login.css";
import axios from "axios";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { AiTwotoneQuestionCircle } from "react-icons/ai";
import yoga from "../../assets/Images/Group 124.png";
import { TbMail } from "react-icons/tb";
import { TbLockPassword } from "react-icons/tb";
import { TbUserCircle } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import vector from "../../assets/Images/Vector 5.png";
import RI from "../../assets/Images/Logo.jpg";
import Swal from "sweetalert2";
import { encrypt, decrypt } from "../../utils/crypto";
import { IoMdArrowBack } from "react-icons/io";

function Register({ onLogin }) {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [isForgot, setIsForgot] = useState(false);

  const [isOtp, setIsOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(0);

  const [isResetPassword, setIsResetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [errors, setErrors] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);

  const [mfapopup, setMfaPopup] = useState(false)

  const [register, setRegister] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [login, setLogin] = useState({
    email: "",
    password: "",
  });

  const [email, setEmail] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [emailFormatShown, setEmailFormatShown] = useState(false);
  const [loginSubmitAttempted, setLoginSubmitAttempted] = useState(false);
  const [forgotEmailError, setForgotEmailError] = useState("");
  const [forgotSubmitAttempted, setForgotSubmitAttempted] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [loginErrors, setLoginErrors] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const email = localStorage.getItem("rememberedEmail");
    const encryptedPassword = localStorage.getItem("rememberedPassword");

    if (email && encryptedPassword) {
      const decrypted = decrypt(encryptedPassword);
      setLogin({ email, password: decrypted });
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
  setIsLogin(true);
  setIsForgot(false);
  setIsOtp(false);
  setIsResetPassword(false);
  setIsRegister(false);
}, []);


  useEffect(() => {
    if(isOtp){
    if (timeLeft <= 0) {
      setIsOtp(false)
      setIsForgot(true);
      return;
    }}

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleForgotToggle = () => {
    setIsForgot(true);
    setIsLogin(false);
  };

  const handleLoginToggle = () => {
    setIsForgot(false);
    setIsLogin(true);
    setIsRegister(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validatePassword = (password) => {
    const validationErrors = [];
    if (password.length < 8) {
      validationErrors.push("Password must be at least 8 characters long.");
    }
    if (!/[A-Z]/.test(password)) {
      validationErrors.push(
        "Password must contain at least one uppercase letter [A-Z]."
      );
    }
    if (!/[a-z]/.test(password)) {
      validationErrors.push(
        "Password must contain at least one lowercase letter [a-z]."
      );
    }
    if (!/[0-9]/.test(password)) {
      validationErrors.push("Password must contain at least one number [0-9].");
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      validationErrors.push(
        'Password must contain at least one special character[!@#$%^&*(),.?":{}|<>].'
      );
    }
    return validationErrors;
  };

  const onRegisterChange = (e) => {
    const { name, value } = e.target;

    const alphabetRegex = /^[A-Za-z\s]*$/;

    if (name === "name") {
      if (!alphabetRegex.test(value)) {
        setNameError("Enter only alphabets");
      } else {
        setNameError("");
      }
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

      if (!emailRegex.test(value)) {
        setEmailFormatShown(true);
      } else {
        setEmailFormatShown(false);
      }

      if (submitAttempted) {
        if (value === "") {
          setEmailError("Email is required.");
        } else if (!emailRegex.test(value)) {
          setEmailError("Enter a valid email.");
        } else {
          setEmailError("");
        }
      }
    }

    setRegister({
      ...register,
      [name]: value,
    });
    if (name === "password") {
      setPasswordTouched(true);

      const errors = validatePassword(value);
      setPasswordErrors(errors);
    }
  };

  const onLoginChange = (e) => {
    setLogin({
      ...login,
      [e.target.name]: e.target.value,
    });
  };

  const onForgotPasswordChange = (e) => {
    setEmail(e.target.value);
  };

  const handleOtpChange = (index, event) => {
    const value = event.target.value;
    if (!/^\d?$/.test(value)) return; 

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

   
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };
  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const toggleNewPasswordVisibility = () =>
    setShowNewPassword(!showNewPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setPasswordTouched(true);

    let isValid = true;

    
    if (!register.name.trim()) {
      setNameError("Name is required.");
      isValid = false;
    } else if (!/^[A-Za-z\s]+$/.test(register.name.trim())) {
      setNameError("Enter only alphabets.");
      isValid = false;
    } else {
      setNameError("");
    }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

if (!register.email.trim()) {
  setEmailError("Email is required.");
  isValid = false;
} else if (!emailRegex.test(register.email.trim())) {
  setEmailError("Enter a valid email address.");
  isValid = false;
} else {
  setEmailError("");
}


   
    const passwordValidation = validatePassword(register.password);
    if (register.password.trim() === "") {
      setPasswordErrors(["Password is required."]);
      isValid = false;
    } else if (passwordValidation.length > 0) {
      setPasswordErrors(passwordValidation);
      isValid = false;
    } else {
      setPasswordErrors([]);
    }

    // Stop if any validation fails
    if (!isValid) return;

    // Proceed with form submission
    try {
      await axios.post(`${baseURL}/api/register`, register);
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "You have been registered successfully.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setIsRegister(false);
      setIsLogin(true);
      setRegister({ name: "", email: "", password: "" });
      setNameError("");
      setEmailError("");
      setPasswordErrors([]);
      setSubmitAttempted(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Error in submitting form or user already registered.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const sendMail = async (event) => {
    event.preventDefault();
    setForgotSubmitAttempted(true);

    if (loading) return;

    // Email validation
    if (!email.trim()) {
      setForgotEmailError("Email is required.");
      return;
    }

    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setForgotEmailError("Enter a valid email.");
      return;
    }

    setForgotEmailError("");
    setLoading(true);

    try {
      const response = await axios.post(`${baseURL}/api/forgot-password`, {
        email,
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "OTP Sent Successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        
      } else {
        Swal.fire({
          icon: response.data.message ? "success" : "error",
          title: response.data.message,
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
      setTimeLeft(300);
      setIsForgot(false);
      setIsOtp(true);
    } catch (error) {
      setErrors("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchProtectedData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${baseURL}/api/protected-route`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return;
    } catch (error) {
      console.error(
        "Error accessing protected route:",
        error.response?.data || error.message
      );
    }
  };

  

const submitLogin = async (e) => {
  e.preventDefault();

  if (loading) return; // prevent double-clicks
  setLoading(true);

  setLoginSubmitAttempted(true);

  let isValid = true;
  const errors = { email: "", password: "" };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  if (!login.email.trim()) {
    errors.email = "Email is required.";
    isValid = false;
  } else if (!emailRegex.test(login.email.trim())) {
    errors.email = "Enter a valid email.";
    isValid = false;
  }

  if (!login.password.trim()) {
    errors.password = "Password is required.";
    isValid = false;
  }

  setLoginErrors(errors);
  if (!isValid) {
    setLoading(false);
    return;
  }

  try {
    const response = await axios.post(
      `${baseURL}/api/login`,
      {
        email: login.email,
        password: login.password,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const saveCredentials = () => {
      localStorage.setItem("token", response.data.accessToken);
      localStorage.setItem("userId", response.data.userId);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem("role", response.data.role);

      if (rememberMe) {
        localStorage.setItem("rememberedEmail", login.email);
        localStorage.setItem("rememberedPassword", encrypt(login.password));
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }
    };
if (response.data.mfaEnabled) {
  Swal.fire({
    title: "Enter MFA Code",
    html: `
      <div style="display: flex; justify-content: center; gap: 10px;">
        <input type="text" id="mfa-1" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
        <input type="text" id="mfa-2" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
        <input type="text" id="mfa-3" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
        <input type="text" id="mfa-4" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
        <input type="text" id="mfa-5" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
        <input type="text" id="mfa-6" maxlength="1" class="mfa-input" style="width: 40px; outline:none; border: 1px solid #ccc; border-radius:5px; height: 40px; font-size: 20px; text-align: center;" />
      </div>
    `,
    focusConfirm: false,
    confirmButtonText: "Verify",
    confirmButtonColor: "#FCB124",
    showCancelButton: true,
    didOpen: () => {
      const inputs = Swal.getPopup().querySelectorAll(".mfa-input");

      inputs.forEach((input, idx) => {
        input.addEventListener("input", () => {
          if (input.value && idx < inputs.length - 1) {
            inputs[idx + 1].focus();
          }
        });

        input.addEventListener("keydown", (e) => {
          if (e.key === "Backspace" && !input.value && idx > 0) {
            inputs[idx - 1].focus();
          }
        });
      });

      // ✅ Handle paste for full 6-digit code
      inputs[0].addEventListener("paste", (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim();
        if (/^\d{6}$/.test(pasteData)) {
          pasteData.split("").forEach((char, i) => {
            if (inputs[i]) inputs[i].value = char;
          });
          inputs[5].focus(); // move focus to last
        }
      });

      inputs[0].focus(); // focus first box
    },
    preConfirm: () => {
      const inputs = Swal.getPopup().querySelectorAll(".mfa-input");
      let code = "";
      inputs.forEach((input) => {
        code += input.value;
      });
      if (code.length !== 6) {
        Swal.showValidationMessage("Please enter all 6 digits");
        return false;
      }
      return code;
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const verifyResponse = await axios.post(
          `${baseURL}/api/verify-mfa`,
          {
            email: login.email,
            code: result.value,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
            if (verifyResponse.data.success) {
              saveCredentials();
              onLogin();
              const role = verifyResponse.data.role;
              if (role === "admin") navigate("/admin");
              else if (role === "researcher") navigate("/researcher");
              else navigate("/dashboard");
              fetchProtectedData();
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Verification Failed",
              text:
                error.response?.data?.message ||
                "Invalid MFA code. Try again.",
              confirmButtonColor: "#FCB124",
              confirmButtonText: "OK",
            });
          }
        }
        setLoading(false); 
      });
    } else {
      saveCredentials();
      onLogin();
      const role = response.data.role;
      if (role === "admin") navigate("/admin");
      else if (role === "researcher") navigate("/researcher");
      else navigate("/dashboard");
      fetchProtectedData();
      setLoading(false);
    }
  } catch (error) {
    const serverMessage = error.response?.data?.message || "";
    const newErrors = { email: "", password: "" };

    if (serverMessage.toLowerCase().includes("email")) {
      newErrors.email = serverMessage;
    }
    if (serverMessage.toLowerCase().includes("password")) {
      newErrors.password = serverMessage;
    }

    setLoginErrors(newErrors);

    Swal.fire({
      icon: "error",
      title: "Login Failed",
      text: serverMessage || "Please try again.",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });

    setLoading(false);
  }
};

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();

    if (/^\d{6}$/.test(paste)) {
      const otpArray = paste.split("");
      setOtp(otpArray);
      const lastInput = document.getElementById(`otp-5`);
      if (lastInput) lastInput.focus();
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    const formattedOtp = Array.isArray(otp) ? otp.join("") : otp;

    try {
      const response = await axios.post(`${baseURL}/api/verify-otp`, {
        email,
        otp: formattedOtp,
      });

      if (response.data.message === "OTP verified successfully!") {
        Swal.fire({
          icon: "success",
          title: "OTP Verified!",
          text: "OTP verified successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
      setIsOtp(false);
      setIsResetPassword(true);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "OTP Verification Failed",
        text: error.response?.data?.message || "Error verifying OTP",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setPasswordTouched(true);
    setPasswordErrors(validatePassword(value));
    setNewPasswordError(errors.length ? "Password is not strong enough." : "");
  };

  // Submit the reset password form
  const submitResetPassword = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setPasswordTouched(true);

    let valid = true;

    if (newPassword.trim() === "") {
      setNewPasswordError("New password is required.");
      valid = false;
    }

    if (confirmPassword.trim() === "") {
      setConfirmPasswordError("Confirm password is required.");
      valid = false;
    }

    if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match.");
      valid = false;
    }

    if (!valid) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/api/reset-password`, {
        email,
        newPassword,
        confirmPassword,
      });

      if (response.status === 200) {
      // show swal alert
      Swal.fire({
        icon: "success",
        title: "Password Reset Successful",
        text: response.data.message || "Your password has been reset.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      }).then(() => {
         setIsResetPassword(false);
      setIsLogin(true); 
      });

      setMessage(response.data.message);
      setNewPassword("");
      setConfirmPassword("");
      setNewPasswordError("");
      setConfirmPasswordError("");
      setPasswordErrors([]);
      setPasswordTouched(false);
      setSubmitAttempted(false);
     
    }
    } catch (error) {
      setMessage(error.response?.data?.message || "Error resetting password.");
    } finally {
      setLoading(false);
    }
  };

  const handlebacklogin = () => {
    setIsForgot(false);
    setIsLogin(true);
  }
  const handlebackloginreset = () => {
    setIsResetPassword(false);
    setIsLogin(true);
  }
 const handlebackloginotp = () => {
    setIsOtp(false);
    setIsLogin(true);
  }
 
  return (
    <>
      <img src={RI} alt="ri" className="ri-logo" />
      <div id="admin-page">
        <div className="left-side-text">
          <img className="log-img"
           
            src={yoga}
            alt="yoga-image"
          />
        </div>
        <div className="form-details">
          {isForgot ? (
            <div className="form-container-login">
              <div>
                <div className="heading">FORGOT PASSWORD</div>
              </div>
              <form onSubmit={sendMail} className="reg-form">
                <div className="reg-form-div">
                  <label className="reg-label">Email<span style={{color:"red"}}>*</span></label>
                  <div className="mail-container">
                    <TbMail className="icon" />
                    <input
                      className="reg-input"
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                      value={email}
                      onChange={onForgotPasswordChange}
                    />
                  </div>
                  {forgotSubmitAttempted && forgotEmailError && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {forgotEmailError}
                    </p>
                  )}
                </div>
                <button
                  className="register"
                  type="submit"
                  disabled={loading}
                  style={{ opacity: loading ? 0.6 : 1 }}
                >
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>
                <div>
                <div className="heading" style={{fontSize:"15px", fontWeight:"500", cursor:"pointer", display:"flex", flexDirection:"row", gap:"5px", alignItems:"center", justifyContent:"center"}} onClick={handlebacklogin}> <IoMdArrowBack style={{color:"#FCB124"}} />Back to Login</div>
              </div>
              </form>
            </div>
          ) : isOtp ? (
            <div className="form-container-login">
              <div>
                <h3 className="heading">ENTER OTP</h3>
              </div>
              <form
                onSubmit={verifyOtp}
                style={{ maxWidth: "400px" }}
                className="reg-form"
              >
                <div className="otp-box">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      className="reg-input"
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={(e) => handlePaste(e)}
                      maxLength="1"
                    />
                  ))}
                </div>
                <div
                  style={{
                    textAlign: "end",
                    color: "grey",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  {timeLeft > 0 && (
                    <p className="otp-timer">
                      OTP expires in {Math.floor(timeLeft / 60)}:
                      {(timeLeft % 60).toString().padStart(2, "0")}
                    </p>
                  )}
                </div>
                <button className="register" type="submit">
                  Submit
                </button>
                   <div className="heading" style={{fontSize:"15px", fontWeight:"500", cursor:"pointer", display:"flex", flexDirection:"row", gap:"5px", alignItems:"center", justifyContent:"center"}} onClick={handlebackloginotp}> <IoMdArrowBack style={{color:"#FCB124"}} />Back to Login</div> 
              </form>
             
            </div>
          ) : isResetPassword ? (
            <div className="form-container-login">
              <div>
                <h3 className="heading">RESET PASSWORD</h3>
              </div>
              {message && <p style={{ color: "red" }}>{message}</p>}
              <form onSubmit={submitResetPassword} className="reg-form">
                <div className="reg-form-div">
                  <label htmlFor="password" className="reg-label">
                    New Password<span style={{color:"red"}}>*</span>
                  </label>
                  <div className="password-input-container">
                    <TbLockPassword className="icon" />
                    <input
                      className="reg-input"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New password"
                      value={newPassword}
                      name="newPassword"
                      autoComplete="off"
                      onChange={handleNewPasswordChange}
                    />
                    {newPassword && (
                      <span
                        className="eye-icon"
                        onClick={toggleNewPasswordVisibility}
                      >
                        {showNewPassword ? <BsEyeSlash /> : <BsEye />}
                      </span>
                    )}
                  </div>
                  {newPasswordError && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {newPasswordError}
                    </p>
                  )}
                  {passwordTouched && passwordErrors.length > 0 && (
                    <ul
                      style={{
                        color: submitAttempted ? "red" : "gray",
                        fontSize: "12px",
                        paddingLeft: "15px",
                      }}
                    >
                      {passwordErrors.map((err, i) => (
                        <li key={i}>{err}</li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="reg-form-div">
                  <label htmlFor="confirmPassword" className="reg-label">
                    Confirm Password<span style={{color:"red"}}>*</span>
                  </label>
                  <div className="password-input-container">
                    <TbLockPassword className="icon" />
                    <input
                      className="reg-input"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      name="confirmNewPassword"
                      autoComplete="off"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {confirmPassword && (
                      <span
                        className="eye-icon"
                        onClick={toggleConfirmPasswordVisibility}
                      >
                        {showConfirmPassword ? <BsEyeSlash /> : <BsEye />}
                      </span>
                    )}
                  </div>
                  {confirmPasswordError && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {confirmPasswordError}
                    </p>
                  )}
                </div>

                <button className="register" type="submit">
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
              </form>
              <div className="heading" style={{fontSize:"15px", fontWeight:"500", cursor:"pointer", display:"flex", flexDirection:"row", gap:"5px", alignItems:"center", justifyContent:"center"}} onClick={handlebackloginreset}> <IoMdArrowBack style={{color:"#FCB124"}} />Back to Login</div>
            </div>
          ) : isRegister ? (
            <div className="form-container-login">
              <div>
                <div className="heading">REGISTRATION</div>
              </div>

              <form onSubmit={handleSubmit} className="reg-form">
                <div className="reg-form-div">
                  <label htmlFor="username" className="reg-label">
                    Name<span style={{color:"red"}}>*</span>
                  </label>
                  <div className="mail-container">
                    <TbUserCircle className="icon" />
                    <input
                      className="reg-input"
                      type="name"
                      value={register.name}
                      id="name"
                      name="name"
                      autoComplete="off"
                      onChange={onRegisterChange}
                      placeholder="Enter name"
                    />
                  </div>
                  {nameError && (submitAttempted || register.name) && (
                    <p
                      style={{ color: "Red", fontSize: "12px" }}
                      className="error-text"
                    >
                      {nameError}
                    </p>
                  )}
                </div>
                
                <div>
                  <label htmlFor="email" className="reg-label">
                    Email<span style={{color:"red"}}>*</span>
                  </label>
                  <div className="mail-container">
                    <TbMail className="icon" />
                    <input
                      className="reg-input"
                      type="email"
                      value={register.email}
                      id="email"
                      name="email"
                      autoComplete="off"
                      onChange={onRegisterChange}
                      placeholder="Enter email"
                    />
                  </div>
                  {emailFormatShown && !submitAttempted && (
                    <p style={{ color: "gray", fontSize: "12px" }}>
                      Email format must be in : example@domain.com
                    </p>
                  )}

                  {submitAttempted && emailError && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {emailError}
                    </p>
                  )}
                </div>
                <div>
                  <div className="circle-ques">
                    <label htmlFor="password" className="reg-label">
                      Password<span style={{color:"red"}}>*</span>
                    </label>
                    <span className="tooltip">
                      <AiTwotoneQuestionCircle />
                    </span>
                  </div>
                  <div className="password-input-container">
                    <TbLockPassword className="icon" />
                    <input
                      className="reg-input"
                      type={showPassword ? "text" : "password"}
                      value={register.password}
                      id="password"
                      name="password"
                      autoComplete="off"
                      onChange={onRegisterChange}
                      onBlur={() => setPasswordTouched(true)}
                      placeholder="Enter password"
                    />
                    {register.password && (
                      <span
                        className="eye-icon"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <BsEyeSlash /> : <BsEye />}
                      </span>
                    )}
                  </div>

                  {passwordTouched && passwordErrors.length > 0 && (
                    <ul className="error-list">
                      {passwordErrors.map((error, index) => (
                        <li
                          key={index}
                          className={`error-item ${
                            submitAttempted ? "highlight" : ""
                          }`}
                        >
                          {error}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <button className="register" type="submit">
                  Sign Up
                </button>

                <div className="login">
                  <p>
                    Already have an account?{" "}
                    <span onClick={handleLoginToggle}  className="link-button">
                      Login
                    </span>
                  </p>
                </div>
              </form>
            </div>
          ) : (
            <>
              {isLogin && (
                <div className="form-container-login">
                  <div>
                    <div className="heading">LOGIN</div>
                  </div>
                  <form onSubmit={submitLogin} className="reg-form">
                    <div className="reg-form-div">
                      <label htmlFor="email" className="reg-label">
                        Email<span style={{color:"red"}}>*</span>
                      </label>
                      <div className="mail-container">
                        <TbMail className="icon" />
                        <input
                          className="reg-input"
                          type="email"
                          value={login.email}
                          id="email"
                          name="email"
                          onChange={onLoginChange}
                          placeholder="Enter your email"
                          autoComplete="off"
                        />
                      </div>
                      {loginSubmitAttempted && loginErrors.email && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {loginErrors.email}
                        </p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="password" className="reg-label">
                        Password<span style={{color:"red"}}>*</span>
                      </label>
                      <div className="password-input-container">
                        <TbLockPassword className="icon" />
                        <input
                          className="reg-input"
                          type={showPassword ? "text" : "password"}
                          value={login.password}
                          id="password"
                          name="password"
                          onChange={onLoginChange}
                          autoComplete="off"
                          placeholder="Enter your password"
                        />
                        {login.password && (
                          <span
                            className="eye-icon"
                            onClick={togglePasswordVisibility}
                          >
                            {showPassword ? <BsEyeSlash /> : <BsEye />}
                          </span>
                        )}
                      </div>
                      {loginSubmitAttempted && loginErrors.password && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {loginErrors.password}
                        </p>
                      )}
                    </div>
                    <div className="rme">
                      <div className="rme-box">
                        <input
                          className="reg-input"
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        <label className="reg-label">Remember Me</label>
                      </div>
                      <div>
                        <span
                          onClick={handleForgotToggle}
                          className="forgot-password-link" 
                        >
                          Forgot Password?
                        </span>
                      </div>
                    </div>
                    <button className="register" type="submit"  disabled={loading}>
                      {loading ? "Please wait..." : "Login"}
                    </button>
                  </form>
                  <div className="login">
                     <p>
                      Don't have an account?{" "}
                      <span
                        onClick={() => setIsRegister(true)}
                        className="link-button"
                      >
                        Register
                      </span>
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div>
        <img
          src={vector}
          alt="vector"
          width="100%"
          style={{ marginTop: "50px" }}
        />
      </div>
    </>
  );
}

export default Register;